import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useCreatePayable } from "@/api/financial";
import { PageHeader } from "@/components/PageHeader";
import { useFarmScope } from "@/hooks/useFarmScope";
import { BillForm } from "./-components/BillForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/financial/payables/new",
)({
	component: NewPayablePage,
});

function NewPayablePage() {
	const { orgId } = Route.useParams();
	const { t } = useTranslation();
	const navigate = Route.useNavigate();
	const scope = useFarmScope();

	const createMutation = useCreatePayable();

	// A bill targets the farm in scope (org-level when "All farms" is selected).
	const establishmentId =
		scope.kind === "single" ? scope.establishmentId : undefined;

	const goToList = () =>
		navigate({ to: "/app/org/$orgId/financial/payables", params: { orgId } });

	return (
		<div className="mx-auto flex w-full max-w-2xl flex-col gap-6">
			<PageHeader
				title={t("financial.payables.form.newTitle")}
				showBackButton
			/>
			<div className="card bg-base-100 shadow-md">
				<div className="card-body">
					<BillForm
						orgId={orgId}
						isSubmitting={createMutation.isPending}
						onSubmit={(data) =>
							createMutation.mutateAsync({
								organizationId: orgId,
								data: {
									...data,
									...(establishmentId ? { establishmentId } : {}),
								},
							})
						}
						onCreated={(billId) =>
							navigate({
								to: "/app/org/$orgId/financial/payables/$billId",
								params: { orgId, billId },
							})
						}
						onCancel={goToList}
					/>
				</div>
			</div>
		</div>
	);
}
